// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 20:48:47

export default {
  "id": "bouncepop-quest",
  "slug": "bouncepop-quest",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/eed7cbc8883e4ff1ad99a951f85c7cf6-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/eed7cbc8883e4ff1ad99a951f85c7cf6/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "BouncePop Quest",
      "description": "Guide Jumpo, a squishy and color-changing jelly creature, through over 150 vibrant levels filled with tricky obstacles, moving platforms, and environmental hazards. Charge and release powerful jumps to collect stars, dodge enemies, and unlock new worlds—from the icy peaks to fiery lava lands. Master timing, aim for achievements, and power up in this cute, bouncy adventure!",
      "instructions": "Press, hold, and release to jump! \nWith double-side jump active, tap left to jump left, right to jump right!",
      "genres": [
        "Adventure",
        "Puzzle"
      ],
      "tags": [
        "1player",
        "2d",
        "happy",
        "levels",
        "relax"
      ]
    },
    "zh-CN": {
      "title": "弹跳泡泡冒险",
      "description": "引导弹跳怪，一个柔软且会变色的果冻生物，穿越超过150个充满挑战性障碍、移动平台和环境危险的五彩斑斓关卡。蓄力并释放强大的跳跃来收集星星，躲避敌人，解锁新的世界——从冰冷的峰顶到炽热的熔岩地带。掌握时机，瞄准成就，在这场可爱、弹跳的冒险中升级！",
      "instructions": "按住、保持、然后释放以跳跃！\n激活双面跳跃后，点击左侧跳跃向左，点击右侧跳跃向右！",
      "genres": [
        "冒险",
        "益智"
      ],
      "tags": [
        "1人游戏",
        "2D",
        "愉快",
        "关卡",
        "放松"
      ]
    },
    "zh-TW": {
      "title": "彈跳泡泡冒險之旅",
      "description": "引導Jumpo這個柔軟且會變色的果冻生物，穿越超過150個充滿挑戰的精彩關卡，關卡內充滿複雜的障礙物、移動平台和環境危險。充電並釋放強大的跳躍力以收集星星、躲避敵人並解鎖新世界——從冰冷的巔峰到火熱的熔岩地帶。掌握時間掌握方向，在這場可愛而 bouncey 的冒險中奪得成就，提升能力！",
      "instructions": "按、按住、放开以跳躍！\n雙面跳躍啟用時，點擊左邊跳躍向左，點擊右邊跳躍向右！",
      "genres": [
        "冒險",
        "謎題"
      ],
      "tags": [
        "1玩家",
        "2D",
        "快樂",
        "關卡",
        "放鬆"
      ]
    },
    "zh-HK": {
      "title": "彈跳泡泡冒險之旅",
      "description": "引導Jumpo，一隻柔軟且會變色的果冻生物，穿越超過150個充滿挑戰的精彩關卡，關卡中充滿了難關、移動平台和環境危險。充電並發射強大的跳躍力，收集星星，避開敵人，並解鎖新世界——從冰峰到火紅的熔岩土地。掌握時間感，追求成就，並在這個可愛彈跳的冒險中強化力量！",
      "instructions": "按、按住、放手以跳躍！\n啟用雙面跳躍功能時，輕觸左邊跳躍左邊，輕觸右邊跳躍右邊！",
      "genres": [
        "冒險",
        "謎題"
      ],
      "tags": [
        "1人遊玩",
        "2D",
        "快樂",
        "關卡",
        "放鬆"
      ]
    },
    "ja": {
      "title": "バウンスポップクエスト",
      "description": "Jumpoという柔らかく色が変わるジェルのような生物を導き、複雑な障害物、動くプラットフォーム、環境の危険が満載の150以上の鮮やかなレベルを乗り越えましょう。強力なジャンプを放って星を集め、敵を避け、新しい世界を解禁します。氷の山から火の溶岩地帯まで、タイミングをマスターし、達成を目指し、この可愛くて弾力的な冒険でパワーアップしましょう！",
      "instructions": "ジャンプするには、押して、保持して、リリース！\nダブルサイドジャンプが有効な場合、左にジャンプするには左をタップ、右にジャンプするには右をタップ！",
      "genres": [
        "冒険",
        "パズル"
      ],
      "tags": [
        "1プレイヤー",
        "2D",
        "ハッピー",
        "レベル",
        "リラックス"
      ]
    },
    "ko": {
      "title": "봉알팝 퀘스트",
      "description": "Jumpo라는 부드럽고 색이 변하는 젤리 생물을 이끌어 150개 이상의 다양한 레벨을 통해 복잡한 장애물, 이동하는 플랫폼, 그리고 환경적 위험을 넘어서세요. 강력한 점프를 사용하여 별을 모으고 적을 피하고 새로운 세계를 열어보세요. 얼음의 봉고지에서 불타는 용암 땅까지, 시간을 훈련하고 성취를 목표로 하며 이 쾌적하고 뛰어오르는 모험에서 강화하세요!",
      "instructions": "프레스하고, 누르고, 놓아주기로 점프하세요! \n양쪽 방향 점프가 활성화되어 있을 때, 왼쪽을 눌러 왼쪽으로 점프, 오른쪽을 눌러 오른쪽으로 점프하세요!",
      "genres": [
        "冒険",
        "퍼즐"
      ],
      "tags": [
        "1플레이어",
        "2D",
        "즐겁다",
        "레벨",
        "편안함"
      ]
    },
    "fr": {
      "title": "Quête BouncePop",
      "description": "Guides Jumpo, une créature gélatineuse et changeante de couleur, à travers plus de 150 niveaux vibrants remplis d'obstacles délicats, de plates-formes mobiles et de dangers environnementaux. Recharge et libère des sauts puissants pour collecter des étoiles, éviter les ennemis et débloquer de nouveaux mondes, des sommets glaciaux aux terres de lave brûlante. Masterisez le temps, visez les succès et renforcez-vous dans cette aventure mignonne et élastique !",
      "instructions": "Pressez, tenez et relâchez pour sauter ! \nAvec le saut double coté actif, appuyez à gauche pour sauter à gauche, à droite pour sauter à droite !",
      "genres": [
        "Aventure",
        "Puzzle"
      ],
      "tags": [
        "1 joueur",
        "2D",
        "heureux",
        "niveaux",
        "se détendre"
      ]
    }
  }
};
